import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMlOzVvlk2T9Gfs84aLK-jIKeBaVhrHGM",
  authDomain: "spried-bb41e.firebaseapp.com",
  databaseURL: "https://spried-bb41e-default-rtdb.firebaseio.com",
  projectId: "spried-bb41e",
  storageBucket: "spried-sheets",
  messagingSenderId: "559502217297",
  appId: "1:559502217297:web:a9409a5058c46ce9c6a870",
  measurementId: "G-F4ZKVQSBDN"
};

const app = initializeApp(firebaseConfig);

// Analytics is optional (not supported in all environments)
export const analyticsPromise = isSupported().then((ok) => (ok ? getAnalytics(app) : null));


// Firestore (default database)
export const db = getFirestore(app,"spried-sheets");

export default app;
